<template>
    <div>
        <Aula :idModulo="idModulo" :mostrar="abrirAula" :aulaEdicao="aula" @abrirNovoAula="abrirAula($event)" @fecharAula="fechar()" @aulaCadastrado="AtualizarAulas($event)" @aulaAtualizado="AtualizarAulas($event)"/>
        <Excluir :mostrar="abrirExcluir" :aula="aula" @aulaExcluida="retirarAulaExcluido($event)" @fecharExcluir="fechar()"/>
        <v-card >
            <v-card-title><h3>Aulas</h3><v-spacer></v-spacer> <v-chip color="primary">Total: {{aulas != undefined ? aulas.length : 0}}</v-chip></v-card-title>
            <v-card-text class="scroll" >
                <v-list>
                    <v-list-item v-for="top in aulas" :key="top.id">
                        <v-icon>mdi-video</v-icon>
                        <v-list-item-content class="ml-2">
                            <v-list-item-title>{{top.nome}}</v-list-item-title>
                        </v-list-item-content>
                        <template>
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" small icon color="primary" @click="editarAula(top)"><v-icon>mdi-pencil</v-icon></v-btn>
                                    </template>
                                    <span>Editar</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </template>
                        <template>
                            <v-list-item-action>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" small icon color="primary" @click="excluirAula(top)"><v-icon>mdi-delete</v-icon></v-btn>
                                    </template>
                                    <span>Deletar</span>
                                </v-tooltip>
                            </v-list-item-action>
                        </template>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small color="primary" @click="AbrirNovoAula()">Novo Aula</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import Aula from '@/components/admin/cursos/Aula'
import Excluir from '@/components/admin/cursos/ExcluirAula'
export default {
    name:"Aulas",
    props:['idModulo', 'aulas'],
    components:{Aula, Excluir},
    data(){
        return{
            abrirAula: false,
            aula: {},
            abrirExcluir: false,
        }
    },
    methods:{
        AbrirNovoAula(){
            this.abrirAula = true
        },

        AtualizarAulas(aula){
            this.$emit('atualizaAulas', aula)
        },

        editarAula(aula){
            this.aula = aula
            this.abrirAula = true
        },
        excluirAula(aula){
            this.aula = aula
            this.abrirExcluir = true
        },
        fechar(){
            this.abrirAula = false
            this.aula = {id: 0}
            this.abrirExcluir = false
        },
        retirarAulaExcluido(id){
            this.$emit('excluirAula', id)
            this.fechar()
        }
    }
}
</script>

<style scoped>
.scroll{
    overflow-y: scroll;
    max-height: 300px;
}
</style>